import { render, staticRenderFns } from "./dive.vue?vue&type=template&id=65d9d807&scoped=true&"
import script from "./dive.vue?vue&type=script&lang=js&"
export * from "./dive.vue?vue&type=script&lang=js&"
import style0 from "./dive.vue?vue&type=style&index=0&id=65d9d807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9d807",
  null
  
)

export default component.exports